import type { CalcProject, CalcSheet } from "../../types/calc";

const projectCache = new Map<string, CalcProject>();
const sheetCache = new Map<string, CalcSheet[]>();

export function getCachedCalcProject(projectId: string) {
  return projectCache.get(projectId) ?? null;
}

export function getCachedCalcSheets(projectId: string) {
  return sheetCache.get(projectId);
}

export function primeCalcProject(project: CalcProject) {
  projectCache.set(project.id, project);
}

export function primeCalcProjects(projects: CalcProject[]) {
  projects.forEach(primeCalcProject);
}

export function cacheCalcProject(projectId: string, project: CalcProject | null) {
  if (project) projectCache.set(projectId, project);
  else projectCache.delete(projectId);
}

export function cacheCalcSheets(projectId: string, sheets: CalcSheet[]) {
  sheetCache.set(projectId, sheets);
}
